import {
  collection,
  getDocs,
  getDoc,
  doc,
  query,
  orderBy,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase-config";

// all transaction (either payment or payout)
export const fetchAllTransactions = async () => {
  try {
    const transactionsRef = collection(db, "transactions");
    const q = query(transactionsRef, orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);

    const transactions = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt?.toDate()?.getTime() || null,
      };
    });

    return transactions;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    return [];
  }
};

// transactions made by user
export const fetchAllPayments = async () => {
  try {
    const transactionsRef = collection(db, "transactions");
    const q = query(transactionsRef, orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);

    const transactions = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt?.toDate()?.getTime() || null,
      };
    });

    return transactions;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    return [];
  }
};

export const fetchAllPayoutClubTrainer = async () => {
  try {
    const transactionsRef = collection(db, "transactions");
    const q = query(transactionsRef, orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);

    const transactions = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt?.toDate()?.getTime() || null,
      };
    });

    return transactions;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    return [];
  }
};

export const fetchAllPayoutClubMember = async () => {
  try {
    const transactionsRef = collection(db, "transactions");
    const q = query(transactionsRef, orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);

    const transactions = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt?.toDate()?.getTime() || null,
      };
    });

    return transactions;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    return [];
  }
};

export const fetchAllPayoutClubAdmin = async () => {
  try {
    const transactionsRef = collection(db, "transactions");
    const q = query(transactionsRef, orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);

    const transactions = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt?.toDate()?.getTime() || null,
      };
    });

    return transactions;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    return [];
  }
};

export const fetchAllPayoutClubLeader = async () => {
  try {
    const transactionsRef = collection(db, "transactions");
    const q = query(transactionsRef, orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);

    const transactions = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt?.toDate()?.getTime() || null,
      };
    });

    return transactions;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    return [];
  }
};

// transactions made by admin
export const fetchAllPayouts = async () => {
  try {
    const transactionsRef = collection(db, "transactions");
    const q = query(transactionsRef, orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);

    const transactions = snapshot.docs.map((doc) => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt?.toDate()?.getTime() || null,
      };
    });

    return transactions;
  } catch (error) {
    console.error("Error fetching transactions:", error);
    return [];
  }
};

export const fetchTransactionById = async (id) => {
  try {
    const docRef = doc(db, "transactions", id);
    const snap = await getDoc(docRef);
    if (!snap.exists()) return null;

    const data = snap.data();
    return {
      id: snap.id,
      ...data,
      createdAt: data.createdAt?.toDate() || null,
    };
  } catch (error) {
    console.error("Error fetching transaction", error);
    return null;
  }
};
export const updateTransactionStatus = async (transactionId, newStatus) => {
  try {
    const transactionRef = doc(db, "transactions", transactionId);
    await updateDoc(transactionRef, { status: newStatus });
    console.log(`Transaction ${transactionId} ${newStatus}`);
  } catch (error) {
    console.error("Error updating transaction:", error);
  }
};
